import { SnowdogMenuNodeInterface } from '@/fo/api/magento';

export const MenuIdentifier = {
  Catalog: 'catalog',
  Brands: 'brands',
  Diagnostic: 'diagnostic',
  AboutSkin: 'about-skin',
  Mobile: 'mobile',
  ToBuyers: 'to-buyers',
  CheckoutFooter: 'checkout-footer',
  BrandsSitemap: 'brands-sitemap'
} as const;

export type MenuIdentifierType =
  (typeof MenuIdentifier)[keyof typeof MenuIdentifier];

export type TreeItem = SnowdogMenuNodeInterface & { children: TreeItem[] };
